const jhscareerTechQuestions = [
  {
    question: "Which of the following tools is used for measuring length in technical drawing?",
    options: [
      "Screwdriver",
      "Ruler",
      "Saw",
      "Pliers"
    ],
    answer: "Ruler"
  },
  
{
  question: "Which of the following best describes personal hygiene?",
  options: [
    "Keeping the environment clean",
    "Keeping the body clean and healthy",
    "Eating regularly",
    "Sleeping often"
  ],
  answer: "Keeping the body clean and healthy"
},
{
  question: "A student washes hands after using the toilet. What is the main purpose of this practice?",
  options: [
    "To look neat",
    "To prevent the spread of germs",
    "To save time",
    "To avoid punishment"
  ],
  answer: "To prevent the spread of germs"
},
{
  question: "Food hygiene is important because it:",
  options: [
    "Makes food taste better",
    "Prevents food contamination and illness",
    "Reduces cooking time",
    "Increases food quantity"
  ],
  answer: "Prevents food contamination and illness"
},
{
  question: "Which of the following is most likely to contaminate food?",
  options: [
    "Clean utensils",
    "Dirty hands",
    "Covered containers",
    "Proper storage"
  ],
  answer: "Dirty hands"
},
{
  question: "A student runs in the workshop and gets injured. Which safety rule was broken?",
  options: [
    "Use correct tools",
    "Avoid running in the workshop",
    "Follow instructions",
    "Wear protective clothing"
  ],
  answer: "Avoid running in the workshop"
},
{
  question: "Which of the following is the best way to prevent accidents in the workshop?",
  options: [
    "Working quickly",
    "Ignoring instructions",
    "Following safety rules",
    "Playing with tools"
  ],
  answer: "Following safety rules"
},
{
  question: "Which of the following is an example of personal protective equipment?",
  options: [
    "Desk",
    "Goggles",
    "Notebook",
    "Chair"
  ],
  answer: "Goggles"
},
{
  question: "Environmental health focuses on:",
  options: [
    "Personal income",
    "Clean and safe surroundings",
    "Buying goods",
    "Sleeping habits"
  ],
  answer: "Clean and safe surroundings"
},
{
  question: "Improper waste disposal can lead to:",
  options: [
    "Clean environment",
    "Disease outbreak",
    "Healthy living",
    "Better sanitation"
  ],
  answer: "Disease outbreak"
},
{
  question: "Which of the following is a correct sanitation practice?",
  options: [
    "Dumping refuse in water",
    "Open defecation",
    "Proper waste disposal",
    "Burning plastics indoors"
  ],
  answer: "Proper waste disposal"
},
{
  question: "Compliant materials are materials that are:",
  options: [
    "Hard and rigid",
    "Flexible and easy to shape",
    "Very heavy",
    "Sharp"
  ],
  answer: "Flexible and easy to shape"
},
{
  question: "Which of the following is a compliant material?",
  options: [
    "Metal",
    "Glass",
    "Paper",
    "Stone"
  ],
  answer: "Paper"
},
{
  question: "Resistant materials are materials that are:",
  options: [
    "Soft and flexible",
    "Hard and not easily shaped",
    "Liquid",
    "Light"
  ],
  answer: "Hard and not easily shaped"
},
{
  question: "Which of the following is a resistant material?",
  options: [
    "Fabric",
    "Paper",
    "Wood",
    "Rubber"
  ],
  answer: "Wood"
},
{
  question: "Which of the following is an example of a plant food commodity?",
  options: [
    "Fish",
    "Milk",
    "Cassava",
    "Meat"
  ],
  answer: "Cassava"
},
{
  question: "Which of the following is an animal food commodity?",
  options: [
    "Rice",
    "Beans",
    "Fish",
    "Maize"
  ],
  answer: "Fish"
},
{
  question: "Food is important because it:",
  options: [
    "Causes diseases",
    "Provides energy and nutrients",
    "Makes people lazy",
    "Wastes time"
  ],
  answer: "Provides energy and nutrients"
},
{
  question: "Which of the following nutrients provides energy to the body?",
  options: [
    "Proteins",
    "Vitamins",
    "Carbohydrates",
    "Minerals"
  ],
  answer: "Carbohydrates"
},
{
  question: "A student eats fruits regularly. What is the main benefit?",
  options: [
    "Weight gain",
    "Supply of vitamins",
    "Increase in fat",
    "Loss of energy"
  ],
  answer: "Supply of vitamins"
},
{
  question: "Which of the following best describes a balanced diet?",
  options: [
    "Eating only carbohydrates",
    "Eating a variety of nutrients in the right proportions",
    "Skipping meals",
    "Eating only fruits"
  ],
  answer: "Eating a variety of nutrients in the right proportions"
},
{
  question: "A student uses a ruler during technical drawing. What is its main function?",
  options: [
    "Cutting materials",
    "Measuring and drawing straight lines",
    "Holding objects",
    "Joining materials"
  ],
  answer: "Measuring and drawing straight lines"
},
{
  question: "Kwame wants to tighten a loose screw on a chair. Which tool should he use?",
  options: [
    "Hammer",
    "Screwdriver",
    "Saw",
    "Chisel"
  ],
  answer: "Screwdriver"
},
{
  question: "A carpenter wants to smooth the surface of wood. Which tool is most suitable?",
  options: [
    "Saw",
    "Plane",
    "Spanner",
    "Hammer"
  ],
  answer: "Plane"
},
{
  question: "Which of the following tools is used for cutting wood?",
  options: [
    "Screwdriver",
    "Hand saw",
    "Spanner",
    "File"
  ],
  answer: "Hand saw"
},
{
  question: "Which tool is used for driving nails into wood?",
  options: [
    "Chisel",
    "Hammer",
    "Plane",
    "Spanner"
  ],
  answer: "Hammer"
},
{
  question: "A farmer uses a tool to cut weeds on the farm. Which tool is this?",
  options: [
    "Hoe",
    "Cutlass",
    "Rake",
    "Watering can"
  ],
  answer: "Cutlass"
},
{
  question: "Which of the following is used for loosening soil in farming?",
  options: [
    "Cutlass",
    "Hoe",
    "Basket",
    "Wheelbarrow"
  ],
  answer: "Hoe"
},
{
  question: "A farmer carries harvested crops from the farm to the house. Which tool is most suitable?",
  options: [
    "Rake",
    "Wheelbarrow",
    "Hoe",
    "Cutlass"
  ],
  answer: "Wheelbarrow"
},
{
  question: "Which of the following is an example of an input device?",
  options: [
    "Monitor",
    "Keyboard",
    "Printer",
    "Speaker"
  ],
  answer: "Keyboard"
},
{
  question: "Which of the following is an output device?",
  options: [
    "Mouse",
    "Keyboard",
    "Monitor",
    "Scanner"
  ],
  answer: "Monitor"
},
{
  question: "A student uses a mouse to click icons on a computer. What type of device is the mouse?",
  options: [
    "Output device",
    "Storage device",
    "Input device",
    "Processing device"
  ],
  answer: "Input device"
},
{
  question: "Which of the following devices stores data permanently?",
  options: [
    "RAM",
    "Hard disk",
    "Keyboard",
    "Monitor"
  ],
  answer: "Hard disk"
},
{
  question: "Which farming method involves growing only one type of crop on a piece of land?",
  options: [
    "Mixed farming",
    "Crop rotation",
    "Monocropping",
    "Irrigation"
  ],
  answer: "Monocropping"
},
{
  question: "A farmer grows maize this year and beans the next year on the same land. What is this practice?",
  options: [
    "Mixed farming",
    "Crop rotation",
    "Irrigation",
    "Shifting cultivation"
  ],
  answer: "Crop rotation"
},
{
  question: "Which of the following improves soil fertility naturally?",
  options: [
    "Plastics",
    "Fertilizers",
    "Pesticides",
    "Weeds"
  ],
  answer: "Fertilizers"
},
{
  question: "Why is irrigation important in farming?",
  options: [
    "It reduces soil nutrients",
    "It supplies water to crops",
    "It destroys crops",
    "It increases pests"
  ],
  answer: "It supplies water to crops"
},
{
  question: "Which of the following is an example of a root crop?",
  options: [
    "Maize",
    "Cassava",
    "Rice",
    "Wheat"
  ],
  answer: "Cassava"
},
{
  question: "Which of the following is a legume crop?",
  options: [
    "Yam",
    "Beans",
    "Maize",
    "Rice"
  ],
  answer: "Beans"
},
{
  question: "A student uses a refrigerator to store food. What is the main purpose?",
  options: [
    "Cooking food",
    "Preserving food",
    "Drying food",
    "Washing food"
  ],
  answer: "Preserving food"
},
{
  question: "Which of the following methods is used to preserve food?",
  options: [
    "Heating",
    "Freezing",
    "Mixing",
    "Cutting"
  ],
  answer: "Freezing"
},
{
  question: "Which of the following fibres is obtained from plants?",
  options: [
    "Wool",
    "Silk",
    "Cotton",
    "Nylon"
  ],
  answer: "Cotton"
},
{
  question: "Which fibre is obtained from animals?",
  options: [
    "Cotton",
    "Linen",
    "Wool",
    "Rayon"
  ],
  answer: "Wool"
},
{
  question: "A student wears light clothing during hot weather. What is the reason?",
  options: [
    "To gain weight",
    "To allow air circulation and keep cool",
    "To look expensive",
    "To reduce movement"
  ],
  answer: "To allow air circulation and keep cool"
},
{
  question: "Which of the following is a synthetic fibre?",
  options: [
    "Cotton",
    "Wool",
    "Nylon",
    "Silk"
  ],
  answer: "Nylon"
},
{
  question: "Why is ironing clothes important?",
  options: [
    "To make clothes heavier",
    "To remove wrinkles and kill germs",
    "To reduce size",
    "To increase cost"
  ],
  answer: "To remove wrinkles and kill germs"
},
{
  question: "Which of the following tools is used in sewing?",
  options: [
    "Spanner",
    "Needle",
    "Saw",
    "Hoe"
  ],
  answer: "Needle"
},
{
  question: "A tailor uses a tape measure. What is its function?",
  options: [
    "Cutting fabric",
    "Measuring body dimensions",
    "Joining materials",
    "Sewing fabric"
  ],
  answer: "Measuring body dimensions"
},
{
  question: "Which of the following kitchen tools is used for cutting food?",
  options: [
    "Spoon",
    "Knife",
    "Plate",
    "Cup"
  ],
  answer: "Knife"
},
{
  question: "A cook uses a spoon while preparing food. What is its main function?",
  options: [
    "Cutting food",
    "Stirring food",
    "Measuring temperature",
    "Holding heat"
  ],
  answer: "Stirring food"
},
{
  question: "Which cooking method involves cooking food in hot oil?",
  options: [
    "Boiling",
    "Frying",
    "Steaming",
    "Roasting"
  ],
  answer: "Frying"
},
{
  question: "Which cooking method uses water as the medium?",
  options: [
    "Frying",
    "Boiling",
    "Grilling",
    "Roasting"
  ],
  answer: "Boiling"
},
{
  question: "A student cooks food using steam from boiling water. What method is used?",
  options: [
    "Frying",
    "Roasting",
    "Steaming",
    "Baking"
  ],
  answer: "Steaming"
},
{
  question: "Which of the following is a property of plastic materials?",
  options: [
    "Very heavy",
    "Easily broken",
    "Light and durable",
    "Conducts electricity"
  ],
  answer: "Light and durable"
},
{
  question: "Which material is most suitable for making cooking pots?",
  options: [
    "Wood",
    "Plastic",
    "Metal",
    "Paper"
  ],
  answer: "Metal"
},
{
  question: "Why is wood commonly used in furniture making?",
  options: [
    "It melts easily",
    "It is strong and durable",
    "It is liquid",
    "It is very soft"
  ],
  answer: "It is strong and durable"
},
{
  question: "Which of the following materials is waterproof?",
  options: [
    "Paper",
    "Fabric",
    "Plastic",
    "Wood"
  ],
  answer: "Plastic"
},
{
  question: "A student selects a material that does not rust for making a water container. Which material is suitable?",
  options: [
    "Iron",
    "Steel",
    "Plastic",
    "Copper"
  ],
  answer: "Plastic"
},
{
  question: "Which of the following is a reason for proper kitchen hygiene?",
  options: [
    "To increase cooking time",
    "To prevent food contamination",
    "To reduce food quantity",
    "To make food expensive"
  ],
  answer: "To prevent food contamination"
},
{
  question: "A cook leaves food uncovered in the kitchen. What is the likely result?",
  options: [
    "Food cooks faster",
    "Food becomes tastier",
    "Food gets contaminated",
    "Food increases in quantity"
  ],
  answer: "Food gets contaminated"
},
{
  question: "Which of the following is the safest way to handle kitchen tools?",
  options: [
    "Play with them",
    "Use them carefully and correctly",
    "Ignore instructions",
    "Run while using them"
  ],
  answer: "Use them carefully and correctly"
},
{
  question: "Which of the following tools is used for drawing circles?",
  options: [
    "Ruler",
    "Compass",
    "Protractor",
    "Set square"
  ],
  answer: "Compass"
},
{
  question: "A student uses a protractor in drawing. What is its main function?",
  options: [
    "Drawing straight lines",
    "Measuring angles",
    "Cutting materials",
    "Joining parts"
  ],
  answer: "Measuring angles"
},
{
  question: "Which of the following tools is used for drawing perpendicular lines?",
  options: [
    "Compass",
    "Set square",
    "Chisel",
    "Hammer"
  ],
  answer: "Set square"
},
{
  question: "A student draws a rough idea before making a product. What is this stage called?",
  options: [
    "Finishing",
    "Designing",
    "Packaging",
    "Marketing"
  ],
  answer: "Designing"
},
{
  question: "Which of the following best describes the design process?",
  options: [
    "Random production",
    "Step-by-step planning and making",
    "Ignoring ideas",
    "Copying others"
  ],
  answer: "Step-by-step planning and making"
},
{
  question: "Which of the following is the first step in making a product?",
  options: [
    "Testing",
    "Designing",
    "Packaging",
    "Selling"
  ],
  answer: "Designing"
},
{
  question: "A structure that supports loads is called:",
  options: [
    "Tool",
    "Machine",
    "Structure",
    "Material"
  ],
  answer: "Structure"
},
{
  question: "Which of the following is an example of a structure?",
  options: [
    "Knife",
    "Bridge",
    "Spoon",
    "Chair cover"
  ],
  answer: "Bridge"
},
{
  question: "Which of the following is a natural force?",
  options: [
    "Electricity",
    "Wind",
    "Hammering",
    "Cutting"
  ],
  answer: "Wind"
},
{
  question: "A building collapses due to poor design. What is the cause?",
  options: [
    "Strong materials",
    "Good planning",
    "Structural failure",
    "Proper construction"
  ],
  answer: "Structural failure"
},
{
  question: "Which of the following helps prevent structural failure?",
  options: [
    "Poor materials",
    "Good design and strong materials",
    "Ignoring instructions",
    "Weak foundation"
  ],
  answer: "Good design and strong materials"
},
{
  question: "Entrepreneurship involves:",
  options: [
    "Working for others only",
    "Starting and managing a business",
    "Avoiding work",
    "Spending money"
  ],
  answer: "Starting and managing a business"
},
{
  question: "A person who starts and runs a business is called:",
  options: [
    "Farmer",
    "Entrepreneur",
    "Teacher",
    "Trader"
  ],
  answer: "Entrepreneur"
},
{
  question: "Which of the following is an example of self-employment?",
  options: [
    "Working in a bank",
    "Running your own shop",
    "Teaching in school",
    "Working in an office"
  ],
  answer: "Running your own shop"
},
{
  question: "Which of the following is a benefit of entrepreneurship?",
  options: [
    "Unemployment",
    "Job creation",
    "Loss of income",
    "Dependence"
  ],
  answer: "Job creation"
},
{
  question: "A student plans how to spend money on a small business. What is this called?",
  options: [
    "Saving",
    "Budgeting",
    "Trading",
    "Spending"
  ],
  answer: "Budgeting"
},
{
  question: "Which of the following helps a business succeed?",
  options: [
    "Poor planning",
    "Hard work and good management",
    "Laziness",
    "Ignoring customers"
  ],
  answer: "Hard work and good management"
},
{
  question: "Which of the following is a source of business capital?",
  options: [
    "Borrowing money",
    "Sleeping",
    "Playing games",
    "Ignoring work"
  ],
  answer: "Borrowing money"
},
{
  question: "A business fails due to poor management. What is the lesson?",
  options: [
    "Management is not important",
    "Good management is necessary",
    "Businesses always fail",
    "Planning is useless"
  ],
  answer: "Good management is necessary"
},
{
  question: "Which of the following is a good business practice?",
  options: [
    "Cheating customers",
    "Selling poor products",
    "Honesty and fairness",
    "Overpricing goods"
  ],
  answer: "Honesty and fairness"
},
{
  question: "Which of the following is used to join pieces of wood together?",
  options: [
    "Glue",
    "Ruler",
    "Compass",
    "Protractor"
  ],
  answer: "Glue"
},
{
  question: "A carpenter uses nails to join wood. Which tool is needed to fix the nails?",
  options: [
    "Saw",
    "Hammer",
    "File",
    "Spanner"
  ],
  answer: "Hammer"
},
{
  question: "Which of the following is used to smooth rough wood surfaces?",
  options: [
    "Hammer",
    "File",
    "Saw",
    "Spanner"
  ],
  answer: "File"
},
{
  question: "A student sands a wooden surface after shaping it. What is the purpose?",
  options: [
    "To make it rough",
    "To smooth and finish the surface",
    "To reduce size",
    "To increase weight"
  ],
  answer: "To smooth and finish the surface"
},
{
  question: "Which of the following is a finishing process in woodwork?",
  options: [
    "Cutting",
    "Joining",
    "Painting",
    "Measuring"
  ],
  answer: "Painting"
},
{
  question: "A worker wears gloves while handling tools. What is the main reason?",
  options: [
    "To look smart",
    "To protect hands from injury",
    "To increase speed",
    "To reduce effort"
  ],
  answer: "To protect hands from injury"
},
{
  question: "Which of the following is the safest way to store tools?",
  options: [
    "Scattered on the floor",
    "Properly arranged in a toolbox",
    "Under the table",
    "Outside in the rain"
  ],
  answer: "Properly arranged in a toolbox"
},
{
  question: "A student cuts food on a dirty surface. What is the likely result?",
  options: [
    "Food cooks faster",
    "Food contamination",
    "Food becomes sweeter",
    "Food increases"
  ],
  answer: "Food contamination"
},
{
  question: "Which of the following nutrients provides body protection against diseases?",
  options: [
    "Carbohydrates",
    "Proteins",
    "Vitamins",
    "Fats"
  ],
  answer: "Vitamins"
},
{
  question: "Which of the following foods is rich in protein?",
  options: [
    "Rice",
    "Fish",
    "Cassava",
    "Sugar"
  ],
  answer: "Fish"
},
{
  question: "A student eats too much fatty food. What is a possible effect?",
  options: [
    "Weight loss",
    "Weight gain",
    "Improved vision",
    "Stronger bones"
  ],
  answer: "Weight gain"
},
{
  question: "Which of the following foods provides energy?",
  options: [
    "Vegetables",
    "Carbohydrates",
    "Vitamins",
    "Water"
  ],
  answer: "Carbohydrates"
},
{
  question: "A cook prepares food using dry heat in an oven. What method is used?",
  options: [
    "Boiling",
    "Frying",
    "Baking",
    "Steaming"
  ],
  answer: "Baking"
},
{
  question: "Which cooking method involves exposing food directly to fire?",
  options: [
    "Boiling",
    "Steaming",
    "Grilling",
    "Frying"
  ],
  answer: "Grilling"
},
{
  question: "A student washes fruits before eating. What is the purpose?",
  options: [
    "To reduce size",
    "To remove dirt and germs",
    "To make them sweet",
    "To increase nutrients"
  ],
  answer: "To remove dirt and germs"
},
{
  question: "Which of the following is a good kitchen practice?",
  options: [
    "Leaving food uncovered",
    "Using clean utensils",
    "Ignoring hygiene",
    "Cooking with dirty hands"
  ],
  answer: "Using clean utensils"
},
{
  question: "A student uses a measuring cup while cooking. What is its purpose?",
  options: [
    "Cutting food",
    "Measuring ingredients",
    "Heating food",
    "Storing food"
  ],
  answer: "Measuring ingredients"
},
{
  question: "Which of the following is a common kitchen hazard?",
  options: [
    "Clean floor",
    "Sharp knife",
    "Proper storage",
    "Covered food"
  ],
  answer: "Sharp knife"
},
{
  question: "A person slips on a wet kitchen floor. What safety measure was ignored?",
  options: [
    "Cleaning utensils",
    "Keeping the floor dry",
    "Cooking properly",
    "Storing food"
  ],
  answer: "Keeping the floor dry"
},
{
  question: "Which of the following is a good personal safety habit?",
  options: [
    "Playing in the workshop",
    "Ignoring instructions",
    "Following safety rules",
    "Running while working"
  ],
  answer: "Following safety rules"
},
{
  question: "Which of the following tools is used for accurate measurement in technical work?",
  options: [
    "Hammer",
    "Ruler",
    "Chisel",
    "File"
  ],
  answer: "Ruler"
},
{
  question: "A student marks a straight line on wood before cutting. What is the purpose?",
  options: [
    "Decoration",
    "Accuracy in cutting",
    "Reducing weight",
    "Speeding up work"
  ],
  answer: "Accuracy in cutting"
},
{
  question: "Which tool is used to make markings on metal surfaces?",
  options: [
    "Pencil",
    "Scriber",
    "Knife",
    "Brush"
  ],
  answer: "Scriber"
},
{
  question: "Which of the following is used for cutting metal?",
  options: [
    "Hand saw",
    "Hacksaw",
    "Plane",
    "Chisel"
  ],
  answer: "Hacksaw"
},
{
  question: "A metalworker uses a file on metal. What is the purpose?",
  options: [
    "Joining metal",
    "Smoothing surfaces",
    "Cutting metal",
    "Measuring metal"
  ],
  answer: "Smoothing surfaces"
},
{
  question: "Which of the following is a safety rule in metalwork?",
  options: [
    "Working without goggles",
    "Using tools carelessly",
    "Wearing protective equipment",
    "Running in the workshop"
  ],
  answer: "Wearing protective equipment"
},
{
  question: "Electric current is best described as:",
  options: [
    "Flow of air",
    "Flow of water",
    "Flow of electric charge",
    "Flow of heat"
  ],
  answer: "Flow of electric charge"
},
{
  question: "Which of the following materials conducts electricity?",
  options: [
    "Plastic",
    "Wood",
    "Copper",
    "Rubber"
  ],
  answer: "Copper"
},
{
  question: "Which of the following materials is an insulator?",
  options: [
    "Copper",
    "Aluminium",
    "Plastic",
    "Iron"
  ],
  answer: "Plastic"
},
{
  question: "A student touches a naked wire and gets shocked. What safety rule was ignored?",
  options: [
    "Wearing gloves",
    "Avoiding contact with live wires",
    "Using tools properly",
    "Following instructions"
  ],
  answer: "Avoiding contact with live wires"
},
{
  question: "Which device is used to switch electrical circuits on and off?",
  options: [
    "Plug",
    "Switch",
    "Wire",
    "Battery"
  ],
  answer: "Switch"
},
{
  question: "Which of the following provides electrical energy in a simple circuit?",
  options: [
    "Wire",
    "Bulb",
    "Battery",
    "Switch"
  ],
  answer: "Battery"
},
{
  question: "A bulb lights up in a circuit. What does this indicate?",
  options: [
    "Broken circuit",
    "Closed circuit",
    "Open circuit",
    "No current"
  ],
  answer: "Closed circuit"
},
{
  question: "Which of the following is a simple electrical appliance?",
  options: [
    "Table",
    "Fan",
    "Chair",
    "Book"
  ],
  answer: "Fan"
},
{
  question: "Why should electrical appliances be handled carefully?",
  options: [
    "To reduce cost",
    "To prevent accidents",
    "To increase weight",
    "To improve appearance"
  ],
  answer: "To prevent accidents"
},
{
  question: "A student plugs many devices into one socket. What is the risk?",
  options: [
    "Improved efficiency",
    "Overloading and fire hazard",
    "Better performance",
    "Reduced electricity"
  ],
  answer: "Overloading and fire hazard"
},
{
  question: "Which of the following is a good electrical safety practice?",
  options: [
    "Touching wires with wet hands",
    "Using damaged cables",
    "Switching off appliances when not in use",
    "Overloading sockets"
  ],
  answer: "Switching off appliances when not in use"
},
{
  question: "Which of the following tools is used for holding hot metal?",
  options: [
    "Hammer",
    "Pliers",
    "Saw",
    "Ruler"
  ],
  answer: "Pliers"
},
{
  question: "A worker uses tongs to handle hot objects. What is the reason?",
  options: [
    "Decoration",
    "Protection from heat",
    "Speed",
    "Weight reduction"
  ],
  answer: "Protection from heat"
},
{
  question: "Which of the following is the safest way to handle tools?",
  options: [
    "Playing with them",
    "Using them correctly",
    "Running with tools",
    "Ignoring instructions"
  ],
  answer: "Using them correctly"
},
{
  question: "Home management is best described as:",
  options: [
    "Cooking only",
    "Managing resources in the home effectively",
    "Cleaning occasionally",
    "Buying goods only"
  ],
  answer: "Managing resources in the home effectively"
},
{
  question: "Which of the following is a resource in the home?",
  options: [
    "Time",
    "Waste",
    "Dirt",
    "Noise"
  ],
  answer: "Time"
},
{
  question: "A student plans how to use time effectively at home. What is this practice called?",
  options: [
    "Spending",
    "Time management",
    "Cooking",
    "Saving"
  ],
  answer: "Time management"
},
{
  question: "Which of the following is a good way to manage time?",
  options: [
    "Delaying tasks",
    "Planning activities",
    "Ignoring duties",
    "Sleeping always"
  ],
  answer: "Planning activities"
},
{
  question: "Consumer education teaches people to:",
  options: [
    "Waste money",
    "Make wise purchasing decisions",
    "Avoid buying goods",
    "Ignore prices"
  ],
  answer: "Make wise purchasing decisions"
},
{
  question: "A student compares prices before buying an item. What is the benefit?",
  options: [
    "Wasting time",
    "Saving money",
    "Increasing cost",
    "Reducing quality"
  ],
  answer: "Saving money"
},
{
  question: "Which of the following is a good consumer habit?",
  options: [
    "Buying without checking quality",
    "Checking expiry dates",
    "Ignoring prices",
    "Buying damaged goods"
  ],
  answer: "Checking expiry dates"
},
{
  question: "Which of the following information is most important on a food label?",
  options: [
    "Colour",
    "Expiry date",
    "Size",
    "Shape"
  ],
  answer: "Expiry date"
},
{
  question: "Packaging of goods is important because it:",
  options: [
    "Increases weight",
    "Protects products from damage",
    "Reduces quality",
    "Wastes materials"
  ],
  answer: "Protects products from damage"
},
{
  question: "Which of the following materials is commonly used for packaging?",
  options: [
    "Stone",
    "Plastic",
    "Soil",
    "Sand"
  ],
  answer: "Plastic"
},
{
  question: "A trader stores goods in a cool, dry place. What is the purpose?",
  options: [
    "To reduce weight",
    "To prevent spoilage",
    "To increase cost",
    "To change colour"
  ],
  answer: "To prevent spoilage"
},
{
  question: "Which of the following is a good storage practice?",
  options: [
    "Leaving goods exposed",
    "Keeping items in proper containers",
    "Mixing all goods together",
    "Ignoring hygiene"
  ],
  answer: "Keeping items in proper containers"
},
{
  question: "Which of the following is an example of perishable goods?",
  options: [
    "Rice",
    "Salt",
    "Fresh fish",
    "Sugar"
  ],
  answer: "Fresh fish"
},
{
  question: "Which of the following is a non-perishable good?",
  options: [
    "Milk",
    "Fish",
    "Rice",
    "Meat"
  ],
  answer: "Rice"
},
{
  question: "A student starts a small business selling snacks. What is this activity called?",
  options: [
    "Employment",
    "Entrepreneurship",
    "Farming",
    "Teaching"
  ],
  answer: "Entrepreneurship"
},
{
  question: "Which of the following is important when starting a business?",
  options: [
    "Laziness",
    "Planning",
    "Ignoring customers",
    "Wasting resources"
  ],
  answer: "Planning"
},
{
  question: "A business owner treats customers well. What is the likely result?",
  options: [
    "Loss of customers",
    "Business growth",
    "Business failure",
    "Increased complaints"
  ],
  answer: "Business growth"
},
{
  question: "Which of the following is a source of business capital?",
  options: [
    "Sleeping",
    "Savings",
    "Playing",
    "Ignoring work"
  ],
  answer: "Savings"
},
{
  question: "A student saves part of pocket money regularly. What is the benefit?",
  options: [
    "Loss of money",
    "Financial security",
    "Waste",
    "Debt"
  ],
  answer: "Financial security"
},
{
  question: "Which of the following is a good financial habit?",
  options: [
    "Spending all income",
    "Saving regularly",
    "Borrowing always",
    "Ignoring expenses"
  ],
  answer: "Saving regularly"
},
{
  question: "A student ignores safety rules in the workshop and gets injured. What is the main lesson?",
  options: [
    "Safety rules are not important",
    "Following safety rules prevents accidents",
    "Work faster next time",
    "Avoid using tools"
  ],
  answer: "Following safety rules prevents accidents"
},
{
  question: "Which of the following best explains why tools must be properly maintained?",
  options: [
    "To increase cost",
    "To ensure efficiency and safety",
    "To reduce usage",
    "To make them heavier"
  ],
  answer: "To ensure efficiency and safety"
},
{
  question: "A carpenter uses a blunt saw and struggles to cut wood. What is the problem?",
  options: [
    "Wrong material",
    "Poor tool maintenance",
    "Good technique",
    "Correct tool use"
  ],
  answer: "Poor tool maintenance"
},
{
  question: "Which of the following best explains why food should be covered?",
  options: [
    "To increase weight",
    "To prevent contamination",
    "To reduce nutrients",
    "To improve colour"
  ],
  answer: "To prevent contamination"
},
{
  question: "A cook prepares food with dirty utensils. What is the likely consequence?",
  options: [
    "Better taste",
    "Food contamination",
    "Faster cooking",
    "Increased quantity"
  ],
  answer: "Food contamination"
},
{
  question: "Which of the following best explains why a balanced diet is important?",
  options: [
    "To increase hunger",
    "To provide all essential nutrients",
    "To reduce body weight only",
    "To avoid eating frequently"
  ],
  answer: "To provide all essential nutrients"
},
{
  question: "A student eats only carbohydrates daily. What is the likely effect?",
  options: [
    "Balanced nutrition",
    "Nutritional deficiency",
    "Improved health",
    "Strong immunity"
  ],
  answer: "Nutritional deficiency"
},
{
  question: "Which of the following best explains why planning is important in production?",
  options: [
    "It delays work",
    "It ensures proper use of resources",
    "It reduces efficiency",
    "It increases waste"
  ],
  answer: "It ensures proper use of resources"
},
{
  question: "A student starts making a product without a plan and fails. What is lacking?",
  options: [
    "Tools",
    "Planning",
    "Materials",
    "Energy"
  ],
  answer: "Planning"
},
{
  question: "Which of the following best explains why strong foundations are important in structures?",
  options: [
    "To increase cost",
    "To support loads effectively",
    "To reduce height",
    "To improve colour"
  ],
  answer: "To support loads effectively"
},
{
  question: "A building collapses due to weak materials. What is the cause?",
  options: [
    "Good design",
    "Structural failure",
    "Proper planning",
    "Strong foundation"
  ],
  answer: "Structural failure"
},
{
  question: "Which of the following best explains why electrical appliances should not be used with wet hands?",
  options: [
    "To reduce efficiency",
    "To prevent electric shock",
    "To improve performance",
    "To save energy"
  ],
  answer: "To prevent electric shock"
},
{
  question: "A student overloads a socket with many devices. What is the likely result?",
  options: [
    "Better performance",
    "Fire hazard",
    "Energy saving",
    "Improved safety"
  ],
  answer: "Fire hazard"
},
{
  question: "Which of the following best explains why materials are selected carefully in production?",
  options: [
    "To increase cost",
    "To ensure suitability for purpose",
    "To reduce durability",
    "To waste resources"
  ],
  answer: "To ensure suitability for purpose"
},
{
  question: "A student chooses plastic instead of metal for a heavy load. What is the likely outcome?",
  options: [
    "Better strength",
    "Failure of product",
    "Improved durability",
    "Reduced weight only"
  ],
  answer: "Failure of product"
},
{
  question: "Which of the following best explains why saving money is important?",
  options: [
    "To increase spending",
    "To prepare for future needs",
    "To avoid income",
    "To reduce planning"
  ],
  answer: "To prepare for future needs"
},
{
  question: "A student spends all income without saving. What is the risk?",
  options: [
    "Financial security",
    "Financial problems",
    "Business growth",
    "Improved planning"
  ],
  answer: "Financial problems"
},
{
  question: "Which of the following best explains why customer satisfaction is important in business?",
  options: [
    "It reduces profit",
    "It attracts more customers",
    "It increases complaints",
    "It delays sales"
  ],
  answer: "It attracts more customers"
},
{
  question: "A business loses customers due to poor service. What is lacking?",
  options: [
    "Capital",
    "Customer care",
    "Products",
    "Location"
  ],
  answer: "Customer care"
},
{
  question: "Which of the following best explains why waste management is important?",
  options: [
    "To increase pollution",
    "To maintain a clean environment",
    "To reduce hygiene",
    "To increase waste"
  ],
  answer: "To maintain a clean environment"
},
{
  question: "A worker chooses the wrong tool for a task and damages the material. What is the main lesson?",
  options: [
    "Tools are not important",
    "Correct tool selection is necessary",
    "Work faster next time",
    "Avoid using tools"
  ],
  answer: "Correct tool selection is necessary"
},
{
  question: "Which of the following best explains why safety training is important in workshops?",
  options: [
    "To reduce productivity",
    "To prevent accidents and injuries",
    "To increase cost",
    "To avoid using tools"
  ],
  answer: "To prevent accidents and injuries"
},
{
  question: "A student uses a metal tool without protective gloves and gets injured. What safety rule was ignored?",
  options: [
    "Use correct materials",
    "Wear protective equipment",
    "Follow instructions",
    "Work quickly"
  ],
  answer: "Wear protective equipment"
},
{
  question: "Which of the following best explains why food should be properly stored?",
  options: [
    "To increase weight",
    "To prevent spoilage and contamination",
    "To reduce nutrients",
    "To change taste"
  ],
  answer: "To prevent spoilage and contamination"
},
{
  question: "A cook stores cooked food in an open container overnight. What is the likely result?",
  options: [
    "Improved taste",
    "Food contamination",
    "Increased quantity",
    "Better preservation"
  ],
  answer: "Food contamination"
},
{
  question: "Which of the following best explains why proper nutrition is important for students?",
  options: [
    "To increase hunger",
    "To support growth and learning",
    "To reduce activity",
    "To avoid exercise"
  ],
  answer: "To support growth and learning"
},
{
  question: "A student skips meals regularly. What is the likely effect?",
  options: [
    "Improved strength",
    "Reduced energy",
    "Better health",
    "Increased weight"
  ],
  answer: "Reduced energy"
},
{
  question: "Which of the following best explains why materials should be tested before use?",
  options: [
    "To waste time",
    "To ensure quality and suitability",
    "To increase cost",
    "To reduce strength"
  ],
  answer: "To ensure quality and suitability"
},
{
  question: "A builder uses weak materials for construction. What is the likely outcome?",
  options: [
    "Strong building",
    "Structural failure",
    "Improved safety",
    "Reduced cost only"
  ],
  answer: "Structural failure"
},
{
  question: "Which of the following best explains why planning is important in business?",
  options: [
    "To delay work",
    "To guide decision-making and success",
    "To increase expenses",
    "To reduce profit"
  ],
  answer: "To guide decision-making and success"
},
{
  question: "A business owner fails due to poor planning. What is the lesson?",
  options: [
    "Planning is not needed",
    "Planning is essential for success",
    "Businesses always fail",
    "Work harder only"
  ],
  answer: "Planning is essential for success"
},
{
  question: "Which of the following best explains why customer feedback is important?",
  options: [
    "To reduce profit",
    "To improve products and services",
    "To increase complaints",
    "To avoid customers"
  ],
  answer: "To improve products and services"
},
{
  question: "A business ignores customer complaints and loses sales. What is lacking?",
  options: [
    "Capital",
    "Customer care",
    "Products",
    "Location"
  ],
  answer: "Customer care"
},
{
  question: "Which of the following best explains why electricity must be used carefully?",
  options: [
    "To increase usage",
    "To prevent accidents and damage",
    "To reduce safety",
    "To increase cost"
  ],
  answer: "To prevent accidents and damage"
},
{
  question: "A student uses damaged electrical wires. What is the risk?",
  options: [
    "Better performance",
    "Electric shock",
    "Energy saving",
    "Improved safety"
  ],
  answer: "Electric shock"
},
{
  question: "Which of the following best explains why proper waste disposal is necessary?",
  options: [
    "To increase pollution",
    "To maintain environmental health",
    "To reduce hygiene",
    "To increase waste"
  ],
  answer: "To maintain environmental health"
},
{
  question: "A community dumps waste into a river. What is the likely effect?",
  options: [
    "Clean water",
    "Water pollution",
    "Improved health",
    "Better sanitation"
  ],
  answer: "Water pollution"
},
{
  question: "Which of the following best explains why budgeting is important in financial management?",
  options: [
    "To increase spending",
    "To control income and expenses",
    "To avoid saving",
    "To reduce planning"
  ],
  answer: "To control income and expenses"
},
{
  question: "A student spends money without planning and faces problems later. What is lacking?",
  options: [
    "Income",
    "Budgeting",
    "Savings",
    "Work"
  ],
  answer: "Budgeting"
},
{
  question: "Which of the following best explains why teamwork is important in production?",
  options: [
    "It reduces efficiency",
    "It improves productivity and cooperation",
    "It increases conflict",
    "It delays work"
  ],
  answer: "It improves productivity and cooperation"
},
{
  question: "A student chooses a wooden material for a structure that carries heavy loads and it breaks. What is the main mistake?",
  options: [
    "Using tools incorrectly",
    "Poor material selection",
    "Lack of design",
    "Poor finishing"
  ],
  answer: "Poor material selection"
},
{
  question: "Which of the following best explains why tools must be used for their specific purposes?",
  options: [
    "To reduce cost",
    "To improve safety and efficiency",
    "To increase workload",
    "To avoid using tools"
  ],
  answer: "To improve safety and efficiency"
},
{
  question: "A cook prepares food in an unclean environment. What is the main risk?",
  options: [
    "Improved taste",
    "Food contamination",
    "Faster cooking",
    "Better nutrition"
  ],
  answer: "Food contamination"
},
{
  question: "Which of the following best explains why kitchen hygiene is important?",
  options: [
    "To increase food quantity",
    "To prevent foodborne diseases",
    "To reduce cooking time",
    "To improve colour"
  ],
  answer: "To prevent foodborne diseases"
},
{
  question: "A student uses too much oil when cooking. What is the likely effect?",
  options: [
    "Balanced diet",
    "Excess fat intake",
    "Improved health",
    "Better digestion"
  ],
  answer: "Excess fat intake"
},
{
  question: "Which of the following best explains why a variety of foods should be eaten?",
  options: [
    "To reduce appetite",
    "To obtain different nutrients",
    "To increase hunger",
    "To avoid cooking"
  ],
  answer: "To obtain different nutrients"
},
{
  question: "A business owner sets very high prices and loses customers. What is the problem?",
  options: [
    "Good marketing",
    "Poor pricing strategy",
    "High demand",
    "Strong business plan"
  ],
  answer: "Poor pricing strategy"
},
{
  question: "Which of the following best explains why good customer relations are important?",
  options: [
    "To reduce profit",
    "To maintain customer loyalty",
    "To increase complaints",
    "To avoid customers"
  ],
  answer: "To maintain customer loyalty"
},
{
  question: "A worker ignores instructions while using machines and causes damage. What is lacking?",
  options: [
    "Tools",
    "Knowledge",
    "Discipline",
    "Materials"
  ],
  answer: "Discipline"
},
{
  question: "Which of the following best explains why instructions must be followed in production?",
  options: [
    "To delay work",
    "To ensure accuracy and safety",
    "To increase cost",
    "To reduce efficiency"
  ],
  answer: "To ensure accuracy and safety"
},
{
  question: "A student uses plastic instead of metal for high heat cooking. What is the likely outcome?",
  options: [
    "Better cooking",
    "Material damage",
    "Improved safety",
    "Reduced heat"
  ],
  answer: "Material damage"
},
{
  question: "Which of the following best explains why metals are used for cooking utensils?",
  options: [
    "They are soft",
    "They conduct heat well",
    "They are light only",
    "They are cheap"
  ],
  answer: "They conduct heat well"
},
{
  question: "A person touches electrical appliances with wet hands. What is the danger?",
  options: [
    "Better performance",
    "Electric shock",
    "Reduced current",
    "Improved safety"
  ],
  answer: "Electric shock"
},
{
  question: "Which of the following best explains why electrical faults should be repaired immediately?",
  options: [
    "To reduce cost",
    "To prevent accidents",
    "To improve design",
    "To increase usage"
  ],
  answer: "To prevent accidents"
},
{
  question: "A student throws waste anywhere in the school. What is the likely effect?",
  options: [
    "Clean environment",
    "Environmental pollution",
    "Improved hygiene",
    "Better sanitation"
  ],
  answer: "Environmental pollution"
},
{
  question: "Which of the following best explains why proper waste disposal is important?",
  options: [
    "To increase dirt",
    "To maintain a healthy environment",
    "To reduce cleanliness",
    "To increase pollution"
  ],
  answer: "To maintain a healthy environment"
},
{
  question: "A student spends all savings on unnecessary items. What is the consequence?",
  options: [
    "Financial growth",
    "Financial difficulty",
    "Better planning",
    "Increased income"
  ],
  answer: "Financial difficulty"
},
{
  question: "Which of the following best explains why saving is important?",
  options: [
    "To increase spending",
    "To prepare for future needs",
    "To avoid work",
    "To reduce income"
  ],
  answer: "To prepare for future needs"
},
{
  question: "A group works together to complete a project faster. What is demonstrated?",
  options: [
    "Competition",
    "Teamwork",
    "Conflict",
    "Laziness"
  ],
  answer: "Teamwork"
},
{
  question: "Which of the following best explains why teamwork is important in production?",
  options: [
    "It delays work",
    "It improves efficiency and output",
    "It increases conflict",
    "It reduces productivity"
  ],
  answer: "It improves efficiency and output"
},
{
  question: "A carpenter selects a weak wood for making a chair and it breaks under weight. What principle was ignored?",
  options: [
    "Tool selection",
    "Material suitability",
    "Finishing",
    "Packaging"
  ],
  answer: "Material suitability"
},
{
  question: "Which of the following best explains why correct measurement is important in production?",
  options: [
    "To increase cost",
    "To ensure accuracy and proper fitting",
    "To delay work",
    "To reduce efficiency"
  ],
  answer: "To ensure accuracy and proper fitting"
},
{
  question: "A student cuts material without measuring and the product does not fit. What is the main mistake?",
  options: [
    "Poor finishing",
    "Lack of measurement",
    "Wrong tool",
    "Bad design"
  ],
  answer: "Lack of measurement"
},
{
  question: "Which of the following best explains why hygiene is important in food preparation?",
  options: [
    "To improve colour",
    "To prevent food poisoning",
    "To increase quantity",
    "To reduce cooking time"
  ],
  answer: "To prevent food poisoning"
},
{
  question: "A cook prepares food with dirty water. What is the likely consequence?",
  options: [
    "Better taste",
    "Food contamination",
    "Faster cooking",
    "Improved nutrition"
  ],
  answer: "Food contamination"
},
{
  question: "Which of the following best explains why different cooking methods are used?",
  options: [
    "To waste time",
    "To suit different types of food",
    "To reduce nutrients",
    "To avoid cooking"
  ],
  answer: "To suit different types of food"
},
{
  question: "A student fries vegetables excessively and they lose nutrients. What is the lesson?",
  options: [
    "Cooking increases nutrients",
    "Wrong cooking method can reduce nutrients",
    "Frying is always best",
    "Food should not be cooked"
  ],
  answer: "Wrong cooking method can reduce nutrients"
},
{
  question: "Which of the following best explains why planning is necessary before starting a business?",
  options: [
    "To increase cost",
    "To guide actions and reduce risks",
    "To delay work",
    "To avoid responsibility"
  ],
  answer: "To guide actions and reduce risks"
},
{
  question: "A business fails because the owner did not study the market. What is lacking?",
  options: [
    "Capital",
    "Market research",
    "Tools",
    "Labour"
  ],
  answer: "Market research"
},
{
  question: "Which of the following best explains why records should be kept in business?",
  options: [
    "To waste time",
    "To track income and expenses",
    "To increase cost",
    "To reduce profit"
  ],
  answer: "To track income and expenses"
},
{
  question: "A business owner cannot account for money spent. What is lacking?",
  options: [
    "Capital",
    "Record keeping",
    "Customers",
    "Products"
  ],
  answer: "Record keeping"
},
{
  question: "Which of the following best explains why electrical appliances must be maintained regularly?",
  options: [
    "To increase usage",
    "To ensure safety and efficiency",
    "To reduce cost",
    "To avoid electricity"
  ],
  answer: "To ensure safety and efficiency"
},
{
  question: "A student uses a faulty electrical appliance and gets shocked. What is the cause?",
  options: [
    "Proper usage",
    "Lack of maintenance",
    "Good wiring",
    "Correct handling"
  ],
  answer: "Lack of maintenance"
},
{
  question: "Which of the following best explains why environmental cleanliness is important?",
  options: [
    "To increase waste",
    "To promote health and safety",
    "To reduce hygiene",
    "To increase pollution"
  ],
  answer: "To promote health and safety"
},
{
  question: "A community experiences frequent diseases due to poor sanitation. What is the main cause?",
  options: [
    "Clean water",
    "Poor environmental hygiene",
    "Good waste management",
    "Healthy practices"
  ],
  answer: "Poor environmental hygiene"
},
{
  question: "Which of the following best explains why budgeting is important in business?",
  options: [
    "To increase spending",
    "To manage finances effectively",
    "To avoid planning",
    "To reduce savings"
  ],
  answer: "To manage finances effectively"
},
{
  question: "A business owner spends money without planning and fails. What is the lesson?",
  options: [
    "Spending increases success",
    "Budgeting is necessary",
    "Planning is useless",
    "Saving is not important"
  ],
  answer: "Budgeting is necessary"
},
{
  question: "Which of the following best explains why teamwork improves productivity?",
  options: [
    "It increases conflict",
    "It combines skills and efforts",
    "It delays work",
    "It reduces output"
  ],
  answer: "It combines skills and efforts"
},
{
  question: "A group fails to complete a task because members do not cooperate. What is lacking?",
  options: [
    "Tools",
    "Teamwork",
    "Materials",
    "Planning"
  ],
  answer: "Teamwork"
},
{
  question: "Which of the following best explains why quality control is important in production?",
  options: [
    "To increase cost",
    "To ensure products meet standards",
    "To delay work",
    "To reduce output"
  ],
  answer: "To ensure products meet standards"
},
{
  question: "A student selects a material without considering its properties and the product fails. What was ignored?",
  options: [
    "Tool usage",
    "Material properties",
    "Finishing",
    "Packaging"
  ],
  answer: "Material properties"
},
{
  question: "Which of the following best explains why materials must be chosen carefully?",
  options: [
    "To increase cost",
    "To ensure durability and suitability",
    "To delay production",
    "To reduce efficiency"
  ],
  answer: "To ensure durability and suitability"
},
{
  question: "A cook leaves food exposed and flies settle on it. What is the likely result?",
  options: [
    "Better taste",
    "Food contamination",
    "Improved hygiene",
    "Increased nutrients"
  ],
  answer: "Food contamination"
},
{
  question: "Which of the following best explains why clean water is important in cooking?",
  options: [
    "To improve colour",
    "To prevent diseases",
    "To reduce cooking time",
    "To increase food quantity"
  ],
  answer: "To prevent diseases"
},
{
  question: "A student cooks food at very high heat and it burns. What is the lesson?",
  options: [
    "High heat is always good",
    "Proper temperature control is important",
    "Cooking time is not important",
    "Food should not be heated"
  ],
  answer: "Proper temperature control is important"
},
{
  question: "Which of the following best explains why cooking methods should be controlled?",
  options: [
    "To waste time",
    "To preserve nutrients and quality",
    "To increase cost",
    "To reduce food quantity"
  ],
  answer: "To preserve nutrients and quality"
},
{
  question: "A business owner starts selling without identifying customer needs. What is the likely outcome?",
  options: [
    "Business growth",
    "Business failure",
    "Increased demand",
    "Better profit"
  ],
  answer: "Business failure"
},
{
  question: "Which of the following best explains why market research is important?",
  options: [
    "To waste time",
    "To understand customer needs",
    "To increase cost",
    "To reduce sales"
  ],
  answer: "To understand customer needs"
},
{
  question: "A business sells poor-quality goods and loses customers. What is lacking?",
  options: [
    "Capital",
    "Quality control",
    "Planning",
    "Tools"
  ],
  answer: "Quality control"
},
{
  question: "Which of the following best explains why quality products are important?",
  options: [
    "To increase complaints",
    "To attract and retain customers",
    "To reduce profit",
    "To delay production"
  ],
  answer: "To attract and retain customers"
},
{
  question: "A worker uses electrical equipment without checking for faults. What is the risk?",
  options: [
    "Improved safety",
    "Electric shock",
    "Better performance",
    "Reduced energy"
  ],
  answer: "Electric shock"
},
{
  question: "Which of the following best explains why electrical inspection is important?",
  options: [
    "To increase usage",
    "To detect faults and prevent accidents",
    "To reduce safety",
    "To increase cost"
  ],
  answer: "To detect faults and prevent accidents"
},
{
  question: "A student dumps waste indiscriminately and the environment becomes dirty. What is lacking?",
  options: [
    "Tools",
    "Environmental responsibility",
    "Materials",
    "Planning"
  ],
  answer: "Environmental responsibility"
},
{
  question: "Which of the following best explains environmental responsibility?",
  options: [
    "Ignoring waste",
    "Taking care of surroundings",
    "Increasing pollution",
    "Avoiding cleaning"
  ],
  answer: "Taking care of surroundings"
},
{
  question: "A student spends money without recording expenses and loses track. What is lacking?",
  options: [
    "Capital",
    "Record keeping",
    "Savings",
    "Income"
  ],
  answer: "Record keeping"
},
{
  question: "Which of the following best explains why financial records are important?",
  options: [
    "To waste time",
    "To monitor financial activities",
    "To increase spending",
    "To reduce profit"
  ],
  answer: "To monitor financial activities"
},
{
  question: "A group project fails due to poor coordination. What is lacking?",
  options: [
    "Tools",
    "Teamwork",
    "Materials",
    "Energy"
  ],
  answer: "Teamwork"
},
{
  question: "Which of the following best explains coordination in teamwork?",
  options: [
    "Working alone",
    "Organizing activities effectively",
    "Ignoring members",
    "Reducing effort"
  ],
  answer: "Organizing activities effectively"
},
{
  question: "A product is poorly finished and unattractive. What is the effect?",
  options: [
    "High demand",
    "Low customer interest",
    "Better quality",
    "Increased durability"
  ],
  answer: "Low customer interest"
},
{
  question: "Which of the following best explains the importance of finishing in production?",
  options: [
    "To reduce quality",
    "To improve appearance and durability",
    "To delay production",
    "To increase cost only"
  ],
  answer: "To improve appearance and durability"
},
{
  question: "A student uses a ruler but reads the measurement wrongly, leading to a faulty product. What is the main issue?",
  options: [
    "Poor finishing",
    "Incorrect reading of measurement",
    "Wrong material",
    "Bad packaging"
  ],
  answer: "Incorrect reading of measurement"
},
{
  question: "Which of the following best explains why careful observation is important in practical work?",
  options: [
    "To waste time",
    "To reduce mistakes",
    "To increase cost",
    "To avoid using tools"
  ],
  answer: "To reduce mistakes"
},
{
  question: "A cook adds too much salt to food, making it inedible. What skill is lacking?",
  options: [
    "Measurement",
    "Cooking speed",
    "Serving",
    "Storage"
  ],
  answer: "Measurement"
},
{
  question: "Which of the following best explains why ingredients must be measured correctly in cooking?",
  options: [
    "To increase quantity",
    "To achieve correct taste and quality",
    "To reduce cooking time",
    "To avoid heating"
  ],
  answer: "To achieve correct taste and quality"
},
{
  question: "A business owner buys goods without checking quality and loses customers. What is the mistake?",
  options: [
    "Poor marketing",
    "Ignoring quality control",
    "High pricing",
    "Low capital"
  ],
  answer: "Ignoring quality control"
},
{
  question: "Which of the following best explains why quality checking is important before selling goods?",
  options: [
    "To delay sales",
    "To ensure customer satisfaction",
    "To increase cost",
    "To reduce production"
  ],
  answer: "To ensure customer satisfaction"
},
{
  question: "A student uses force incorrectly while cutting material and damages it. What is lacking?",
  options: [
    "Skill",
    "Material",
    "Tool",
    "Design"
  ],
  answer: "Skill"
},
{
  question: "Which of the following best explains skill in practical work?",
  options: [
    "Working without thinking",
    "Ability to perform tasks correctly",
    "Using many tools",
    "Working slowly"
  ],
  answer: "Ability to perform tasks correctly"
},
{
  question: "A worker ignores small cracks in a structure and it later collapses. What was ignored?",
  options: [
    "Decoration",
    "Early fault detection",
    "Painting",
    "Packaging"
  ],
  answer: "Early fault detection"
},
{
  question: "Which of the following best explains why regular inspection is important?",
  options: [
    "To increase cost",
    "To detect faults early",
    "To reduce work",
    "To delay production"
  ],
  answer: "To detect faults early"
},
{
  question: "A student stores food in a hot place and it spoils quickly. What is the mistake?",
  options: [
    "Good storage",
    "Poor storage conditions",
    "Proper hygiene",
    "Correct packaging"
  ],
  answer: "Poor storage conditions"
},
{
  question: "Which of the following best explains why temperature control is important in food storage?",
  options: [
    "To increase weight",
    "To slow down spoilage",
    "To reduce nutrients",
    "To improve colour"
  ],
  answer: "To slow down spoilage"
},
{
  question: "A student spends money on unnecessary items and cannot meet basic needs. What is lacking?",
  options: [
    "Income",
    "Prioritization",
    "Work",
    "Tools"
  ],
  answer: "Prioritization"
},
{
  question: "Which of the following best explains prioritization in financial management?",
  options: [
    "Spending randomly",
    "Choosing important needs first",
    "Avoiding spending",
    "Saving everything"
  ],
  answer: "Choosing important needs first"
},
{
  question: "A business grows because it adapts to customer needs. What principle is applied?",
  options: [
    "Rigidity",
    "Flexibility",
    "Waste",
    "Delay"
  ],
  answer: "Flexibility"
},
{
  question: "Which of the following best explains flexibility in business?",
  options: [
    "Ignoring customers",
    "Adjusting to changes and demands",
    "Reducing products",
    "Avoiding planning"
  ],
  answer: "Adjusting to changes and demands"
},
{
  question: "A student works alone on a group task and delays completion. What is lacking?",
  options: [
    "Tools",
    "Teamwork",
    "Materials",
    "Energy"
  ],
  answer: "Teamwork"
},
{
  question: "Which of the following best explains cooperation in teamwork?",
  options: [
    "Working individually",
    "Working together effectively",
    "Ignoring others",
    "Competing always"
  ],
  answer: "Working together effectively"
},
{
  question: "A product is strong but poorly designed and unattractive. What is the effect?",
  options: [
    "High demand",
    "Low market appeal",
    "Better durability",
    "Increased value"
  ],
  answer: "Low market appeal"
},
{
  question: "Which of the following best explains the importance of design in production?",
  options: [
    "To increase cost",
    "To improve function and appearance",
    "To delay work",
    "To reduce quality"
  ],
  answer: "To improve function and appearance"
},
{
  question: "A student rushes through a task and produces a poorly finished product. What is the main issue?",
  options: [
    "Lack of tools",
    "Poor time management",
    "Wrong material",
    "Bad packaging"
  ],
  answer: "Poor time management"
},
{
  question: "Which of the following best explains why patience is important in practical work?",
  options: [
    "To delay production",
    "To improve quality of work",
    "To reduce effort",
    "To avoid tools"
  ],
  answer: "To improve quality of work"
},
{
  question: "A cook prepares food without tasting it and serves it salty. What is lacking?",
  options: [
    "Measurement",
    "Quality control",
    "Cooking method",
    "Storage"
  ],
  answer: "Quality control"
},
{
  question: "Which of the following best explains quality control in food preparation?",
  options: [
    "Cooking quickly",
    "Checking food before serving",
    "Adding more ingredients",
    "Storing food"
  ],
  answer: "Checking food before serving"
},
{
  question: "A trader buys goods in bulk but cannot sell them. What is the main problem?",
  options: [
    "Low capital",
    "Poor market demand analysis",
    "High quality",
    "Good planning"
  ],
  answer: "Poor market demand analysis"
},
{
  question: "Which of the following best explains demand in business?",
  options: [
    "Amount produced",
    "Customer desire for goods",
    "Cost of goods",
    "Business location"
  ],
  answer: "Customer desire for goods"
},
{
  question: "A student uses excessive force while assembling parts and breaks them. What is lacking?",
  options: [
    "Material",
    "Skill and control",
    "Design",
    "Tools"
  ],
  answer: "Skill and control"
},
{
  question: "Which of the following best explains control in practical work?",
  options: [
    "Working fast",
    "Using appropriate force and technique",
    "Ignoring tools",
    "Avoiding effort"
  ],
  answer: "Using appropriate force and technique"
},
{
  question: "A structure is built without proper alignment and becomes unstable. What is the cause?",
  options: [
    "Good design",
    "Poor alignment",
    "Strong materials",
    "Proper foundation"
  ],
  answer: "Poor alignment"
},
{
  question: "Which of the following best explains alignment in construction?",
  options: [
    "Decoration",
    "Correct positioning of parts",
    "Painting",
    "Cutting"
  ],
  answer: "Correct positioning of parts"
},
{
  question: "A student stores perishable food with non-perishable goods and contamination occurs. What is lacking?",
  options: [
    "Tools",
    "Proper storage separation",
    "Cooking",
    "Measurement"
  ],
  answer: "Proper storage separation"
},
{
  question: "Which of the following best explains proper storage practices?",
  options: [
    "Mixing all items",
    "Separating and organizing items correctly",
    "Ignoring hygiene",
    "Leaving items open"
  ],
  answer: "Separating and organizing items correctly"
},
{
  question: "A student spends money on wants instead of needs and faces difficulty. What is the mistake?",
  options: [
    "Saving",
    "Wrong prioritization",
    "Budgeting",
    "Income"
  ],
  answer: "Wrong prioritization"
},
{
  question: "Which of the following best explains needs in financial management?",
  options: [
    "Things we desire",
    "Essential items for survival",
    "Luxury goods",
    "Expensive items"
  ],
  answer: "Essential items for survival"
},
{
  question: "A business refuses to change its products despite low sales. What is lacking?",
  options: [
    "Consistency",
    "Adaptability",
    "Planning",
    "Capital"
  ],
  answer: "Adaptability"
},
{
  question: "Which of the following best explains adaptability in business?",
  options: [
    "Refusing change",
    "Adjusting to market conditions",
    "Reducing products",
    "Ignoring customers"
  ],
  answer: "Adjusting to market conditions"
},
{
  question: "A group argues constantly and fails to complete a task. What is lacking?",
  options: [
    "Tools",
    "Communication",
    "Materials",
    "Energy"
  ],
  answer: "Communication"
},
{
  question: "Which of the following best explains effective communication in teamwork?",
  options: [
    "Ignoring others",
    "Sharing ideas clearly",
    "Working alone",
    "Competing always"
  ],
  answer: "Sharing ideas clearly"
},
{
  question: "A product is well designed but poorly marketed and does not sell. What is lacking?",
  options: [
    "Quality",
    "Marketing strategy",
    "Design",
    "Production"
  ],
  answer: "Marketing strategy"
},
{
  question: "Which of the following best explains marketing in business?",
  options: [
    "Producing goods",
    "Promoting and selling products",
    "Storing goods",
    "Buying materials"
  ],
  answer: "Promoting and selling products"
},
{
  question: "A student produces a well-designed product but it fails during use. What is the main issue?",
  options: [
    "Poor design",
    "Lack of testing",
    "Wrong packaging",
    "Bad marketing"
  ],
  answer: "Lack of testing"
},
{
  question: "Which of the following best explains why testing is important before final production?",
  options: [
    "To increase cost",
    "To identify and correct faults",
    "To delay work",
    "To reduce quality"
  ],
  answer: "To identify and correct faults"
},
{
  question: "A cook prepares food but does not serve it properly, making it unattractive. What is lacking?",
  options: [
    "Cooking skill",
    "Presentation",
    "Storage",
    "Measurement"
  ],
  answer: "Presentation"
},
{
  question: "Which of the following best explains food presentation?",
  options: [
    "Cooking food quickly",
    "Arranging food attractively",
    "Storing food",
    "Measuring ingredients"
  ],
  answer: "Arranging food attractively"
},
{
  question: "A business produces good products but fails due to poor advertisement. What is lacking?",
  options: [
    "Production",
    "Marketing",
    "Planning",
    "Capital"
  ],
  answer: "Marketing"
},
{
  question: "Which of the following best explains advertisement in business?",
  options: [
    "Buying goods",
    "Creating awareness of products",
    "Producing goods",
    "Storing goods"
  ],
  answer: "Creating awareness of products"
},
{
  question: "A worker ignores minor faults in a machine until it breaks down completely. What is lacking?",
  options: [
    "Skill",
    "Maintenance culture",
    "Material",
    "Design"
  ],
  answer: "Maintenance culture"
},
{
  question: "Which of the following best explains maintenance in technology?",
  options: [
    "Using tools",
    "Regular checking and repair",
    "Producing goods",
    "Designing products"
  ],
  answer: "Regular checking and repair"
},
{
  question: "A student uses too much material and wastes resources. What is lacking?",
  options: [
    "Planning",
    "Resource management",
    "Skill",
    "Tools"
  ],
  answer: "Resource management"
},
{
  question: "Which of the following best explains efficient use of resources?",
  options: [
    "Using excess materials",
    "Minimizing waste",
    "Ignoring planning",
    "Increasing cost"
  ],
  answer: "Minimizing waste"
},
{
  question: "A structure is strong but not stable due to uneven base. What is the cause?",
  options: [
    "Strong materials",
    "Poor foundation",
    "Good design",
    "Proper alignment"
  ],
  answer: "Poor foundation"
},
{
  question: "Which of the following best explains stability in structures?",
  options: [
    "Attractive design",
    "Ability to remain balanced and upright",
    "Light weight",
    "Small size"
  ],
  answer: "Ability to remain balanced and upright"
},
{
  question: "A student mixes raw and cooked food together and contamination occurs. What is lacking?",
  options: [
    "Cooking skill",
    "Food safety practice",
    "Measurement",
    "Storage"
  ],
  answer: "Food safety practice"
},
{
  question: "Which of the following best explains food safety?",
  options: [
    "Cooking quickly",
    "Handling food properly to avoid contamination",
    "Storing food only",
    "Eating frequently"
  ],
  answer: "Handling food properly to avoid contamination"
},
{
  question: "A student spends all money on luxury items and cannot pay school fees. What is lacking?",
  options: [
    "Income",
    "Financial discipline",
    "Saving",
    "Planning"
  ],
  answer: "Financial discipline"
},
{
  question: "Which of the following best explains financial discipline?",
  options: [
    "Spending freely",
    "Managing money wisely",
    "Avoiding income",
    "Ignoring expenses"
  ],
  answer: "Managing money wisely"
},
{
  question: "A business grows because it maintains good relationships with customers. What is demonstrated?",
  options: [
    "Competition",
    "Customer relations",
    "Production",
    "Marketing"
  ],
  answer: "Customer relations"
},
{
  question: "Which of the following best explains customer relations?",
  options: [
    "Ignoring customers",
    "Building trust and satisfaction",
    "Reducing products",
    "Increasing prices"
  ],
  answer: "Building trust and satisfaction"
},
{
  question: "A team completes a project successfully because each member performs their role. What is demonstrated?",
  options: [
    "Competition",
    "Role allocation",
    "Conflict",
    "Independence"
  ],
  answer: "Role allocation"
},
{
  question: "Which of the following best explains role allocation in teamwork?",
  options: [
    "Working alone",
    "Assigning specific duties to members",
    "Ignoring members",
    "Competing always"
  ],
  answer: "Assigning specific duties to members"
},
{
  question: "A student completes a project without checking for errors and submits a faulty product. What is lacking?",
  options: [
    "Design",
    "Evaluation",
    "Material",
    "Packaging"
  ],
  answer: "Evaluation"
},
{
  question: "Which of the following best explains evaluation in production?",
  options: [
    "Starting work",
    "Checking and assessing the final product",
    "Buying materials",
    "Selling goods"
  ],
  answer: "Checking and assessing the final product"
},
{
  question: "A cook prepares food but serves it cold when it should be hot. What is the issue?",
  options: [
    "Cooking method",
    "Temperature control",
    "Storage",
    "Measurement"
  ],
  answer: "Temperature control"
},
{
  question: "Which of the following best explains temperature control in food preparation?",
  options: [
    "Cooking quickly",
    "Maintaining appropriate heat levels",
    "Storing food",
    "Measuring ingredients"
  ],
  answer: "Maintaining appropriate heat levels"
},
{
  question: "A business produces goods but fails due to poor location. What factor was ignored?",
  options: [
    "Capital",
    "Location",
    "Marketing",
    "Production"
  ],
  answer: "Location"
},
{
  question: "Which of the following best explains why location is important in business?",
  options: [
    "To increase cost",
    "To reach customers easily",
    "To reduce quality",
    "To delay production"
  ],
  answer: "To reach customers easily"
},
{
  question: "A worker continues using a damaged tool and produces poor results. What is lacking?",
  options: [
    "Skill",
    "Tool inspection",
    "Material",
    "Design"
  ],
  answer: "Tool inspection"
},
{
  question: "Which of the following best explains tool inspection?",
  options: [
    "Using tools quickly",
    "Checking tools before use",
    "Buying tools",
    "Storing tools"
  ],
  answer: "Checking tools before use"
},
{
  question: "A student stores tools carelessly and cannot find them when needed. What is lacking?",
  options: [
    "Tools",
    "Organization",
    "Materials",
    "Energy"
  ],
  answer: "Organization"
},
{
  question: "Which of the following best explains organization in the workshop?",
  options: [
    "Scattering tools",
    "Arranging tools properly",
    "Ignoring tools",
    "Using tools randomly"
  ],
  answer: "Arranging tools properly"
},
{
  question: "A structure is attractive but collapses easily. What is lacking?",
  options: [
    "Design",
    "Strength",
    "Colour",
    "Decoration"
  ],
  answer: "Strength"
},
{
  question: "Which of the following best explains strength in structures?",
  options: [
    "Appearance",
    "Ability to carry loads",
    "Colour",
    "Shape only"
  ],
  answer: "Ability to carry loads"
},
{
  question: "A student leaves food uncovered and insects contaminate it. What is lacking?",
  options: [
    "Cooking",
    "Food protection",
    "Measurement",
    "Storage"
  ],
  answer: "Food protection"
},
{
  question: "Which of the following best explains food protection?",
  options: [
    "Cooking food",
    "Preventing contamination",
    "Storing food only",
    "Serving food"
  ],
  answer: "Preventing contamination"
},
{
  question: "A student earns money but spends everything without saving. What is lacking?",
  options: [
    "Income",
    "Saving habit",
    "Planning",
    "Work"
  ],
  answer: "Saving habit"
},
{
  question: "Which of the following best explains saving?",
  options: [
    "Spending all money",
    "Keeping part of income for future use",
    "Avoiding income",
    "Ignoring expenses"
  ],
  answer: "Keeping part of income for future use"
},
{
  question: "A business fails because it does not compete well with others. What is lacking?",
  options: [
    "Production",
    "Competitiveness",
    "Tools",
    "Materials"
  ],
  answer: "Competitiveness"
},
{
  question: "Which of the following best explains competitiveness in business?",
  options: [
    "Ignoring competitors",
    "Offering better value than others",
    "Reducing quality",
    "Avoiding customers"
  ],
  answer: "Offering better value than others"
},
{
  question: "A team fails because members do not understand their tasks. What is lacking?",
  options: [
    "Tools",
    "Clear instructions",
    "Materials",
    "Energy"
  ],
  answer: "Clear instructions"
},
{
  question: "Which of the following best explains the importance of clear instructions?",
  options: [
    "To confuse workers",
    "To ensure tasks are done correctly",
    "To delay work",
    "To reduce productivity"
  ],
  answer: "To ensure tasks are done correctly"
},
{
  question: "A student completes a task but ignores feedback and repeats the same mistakes. What is lacking?",
  options: [
    "Tools",
    "Improvement mindset",
    "Materials",
    "Energy"
  ],
  answer: "Improvement mindset"
},
{
  question: "Which of the following best explains continuous improvement in practical work?",
  options: [
    "Repeating errors",
    "Learning from mistakes and improving",
    "Avoiding work",
    "Ignoring feedback"
  ],
  answer: "Learning from mistakes and improving"
},
{
  question: "A cook prepares food without considering the number of people and food becomes insufficient. What is lacking?",
  options: [
    "Cooking skill",
    "Planning and estimation",
    "Storage",
    "Measurement"
  ],
  answer: "Planning and estimation"
},
{
  question: "Which of the following best explains estimation in cooking?",
  options: [
    "Cooking randomly",
    "Judging quantities appropriately",
    "Avoiding measurement",
    "Reducing food"
  ],
  answer: "Judging quantities appropriately"
},
{
  question: "A business produces goods but ignores competitors and loses customers. What is lacking?",
  options: [
    "Production",
    "Market awareness",
    "Capital",
    "Tools"
  ],
  answer: "Market awareness"
},
{
  question: "Which of the following best explains market awareness?",
  options: [
    "Ignoring competition",
    "Understanding competitors and trends",
    "Reducing products",
    "Avoiding customers"
  ],
  answer: "Understanding competitors and trends"
},
{
  question: "A worker uses tools in a disorderly manner and wastes time. What is lacking?",
  options: [
    "Skill",
    "Work discipline",
    "Materials",
    "Design"
  ],
  answer: "Work discipline"
},
{
  question: "Which of the following best explains discipline in practical work?",
  options: [
    "Working carelessly",
    "Following rules and procedures",
    "Avoiding tasks",
    "Using tools randomly"
  ],
  answer: "Following rules and procedures"
},
{
  question: "A structure is strong but poorly maintained and becomes weak over time. What is lacking?",
  options: [
    "Design",
    "Maintenance",
    "Materials",
    "Alignment"
  ],
  answer: "Maintenance"
},
{
  question: "Which of the following best explains maintenance in structures?",
  options: [
    "Ignoring faults",
    "Regular care and repair",
    "Building only",
    "Designing only"
  ],
  answer: "Regular care and repair"
},
{
  question: "A student stores food properly but forgets to check expiry dates. What is lacking?",
  options: [
    "Cooking skill",
    "Attention to detail",
    "Storage",
    "Measurement"
  ],
  answer: "Attention to detail"
},
{
  question: "Which of the following best explains attention to detail?",
  options: [
    "Ignoring small issues",
    "Focusing on important details",
    "Working quickly",
    "Avoiding checks"
  ],
  answer: "Focusing on important details"
},
{
  question: "A student earns money but fails to track spending and savings. What is lacking?",
  options: [
    "Income",
    "Financial tracking",
    "Planning",
    "Work"
  ],
  answer: "Financial tracking"
},
{
  question: "Which of the following best explains financial tracking?",
  options: [
    "Ignoring expenses",
    "Monitoring income and spending",
    "Spending freely",
    "Avoiding saving"
  ],
  answer: "Monitoring income and spending"
},
{
  question: "A business produces high-quality goods but sells them at very low prices and makes losses. What is lacking?",
  options: [
    "Production",
    "Pricing strategy",
    "Marketing",
    "Planning"
  ],
  answer: "Pricing strategy"
},
{
  question: "Which of the following best explains pricing strategy?",
  options: [
    "Selling randomly",
    "Setting prices based on cost and demand",
    "Reducing quality",
    "Avoiding profit"
  ],
  answer: "Setting prices based on cost and demand"
},
{
  question: "A team fails because members do not respect each other's ideas. What is lacking?",
  options: [
    "Tools",
    "Mutual respect",
    "Materials",
    "Energy"
  ],
  answer: "Mutual respect"
},
{
  question: "Which of the following best explains respect in teamwork?",
  options: [
    "Ignoring others",
    "Valuing others� contributions",
    "Working alone",
    "Competing always"
  ],
  answer: "Valuing others� contributions"
},
{
  question: "A product is functional but lacks creativity and fails in the market. What is lacking?",
  options: [
    "Strength",
    "Creativity",
    "Design",
    "Materials"
  ],
  answer: "Creativity"
},
{
  question: "Which of the following best explains creativity in production?",
  options: [
    "Copying others",
    "Generating new and useful ideas",
    "Avoiding design",
    "Reducing quality"
  ],
  answer: "Generating new and useful ideas"
},
{
  question: "Which of the following is the first step in giving first aid to an injured person?",
  options: [
    "Give food",
    "Assess the situation and ensure safety",
    "Run away",
    "Ignore the victim"
  ],
  answer: "Assess the situation and ensure safety"
},
{
  question: "Which of the following is used to stop bleeding during first aid?",
  options: [
    "Bandage",
    "Paint",
    "Glue",
    "Oil"
  ],
  answer: "Bandage"
},
{
  question: "Smart materials are best described as materials that:",
  options: [
    "Are always heavy",
    "Respond to changes in the environment",
    "Are very cheap",
    "Are used only in cooking"
  ],
  answer: "Respond to changes in the environment"
},
{
  question: "Which of the following is an example of a smart material?",
  options: [
    "Wood",
    "Plastic",
    "Shape memory alloy",
    "Stone"
  ],
  answer: "Shape memory alloy"
},
{
  question: "Which of the following forces pulls objects apart?",
  options: [
    "Compression",
    "Tension",
    "Twisting",
    "Bending"
  ],
  answer: "Tension"
},
{
  question: "Which of the following forces pushes objects together?",
  options: [
    "Tension",
    "Compression",
    "Stretching",
    "Pulling"
  ],
  answer: "Compression"
},
{
  question: "Which of the following is a cutting tool?",
  options: [
    "Hammer",
    "Saw",
    "Spanner",
    "File"
  ],
  answer: "Saw"
},
{
  question: "Which of the following is a measuring tool?",
  options: [
    "Chisel",
    "Ruler",
    "Hammer",
    "Saw"
  ],
  answer: "Ruler"
},
{
  question: "Which of the following is a joining tool?",
  options: [
    "Hammer",
    "Ruler",
    "Compass",
    "Protractor"
  ],
  answer: "Hammer"
},
{
  question: "Which of the following is the correct order of the design process?",
  options: [
    "Make ? Design ? Evaluate",
    "Design ? Make ? Evaluate",
    "Evaluate ? Design ? Make",
    "Make ? Evaluate ? Design"
  ],
  answer: "Design ? Make ? Evaluate"
},
{
  question: "Which of the following is part of garment care?",
  options: [
    "Painting clothes",
    "Washing and ironing",
    "Cutting fabric",
    "Designing clothes"
  ],
  answer: "Washing and ironing"
},
{
  question: "Which of the following is the correct way to wash clothes?",
  options: [
    "Mix all colours",
    "Separate colours before washing",
    "Use dirty water",
    "Avoid soap"
  ],
  answer: "Separate colours before washing"
},
{
  question: "Which of the following symbols represents a battery in a circuit?",
  options: [
    "Two unequal parallel lines",
    "Circle only",
    "Zigzag line",
    "Square"
  ],
  answer: "Two unequal parallel lines"
},
{
  question: "Which of the following symbols represents a bulb in a circuit?",
  options: [
    "Straight line",
    "Circle with a cross inside",
    "Triangle",
    "Rectangle"
  ],
  answer: "Circle with a cross inside"
},
{
  question: "Which of the following best explains an open circuit?",
  options: [
    "Current flows",
    "No current flows",
    "Circuit is complete",
    "Bulb lights"
  ],
  answer: "No current flows"
},
{
  question: "Which of the following best explains a closed circuit?",
  options: [
    "No current flows",
    "Current flows",
    "Wire is broken",
    "No energy"
  ],
  answer: "Current flows"
},
{
  question: "Which of the following is the best way to handle electrical faults?",
  options: [
    "Ignore them",
    "Report and repair immediately",
    "Use them anyway",
    "Touch wires"
  ],
  answer: "Report and repair immediately"
},
{
  question: "Which of the following is a safe first aid practice?",
  options: [
    "Ignoring injuries",
    "Treating wounds immediately",
    "Running away",
    "Using dirty materials"
  ],
  answer: "Treating wounds immediately"
},
{
  question: "Which of the following best explains classification of tools?",
  options: [
    "Grouping tools randomly",
    "Grouping tools based on their uses",
    "Ignoring tools",
    "Mixing all tools"
  ],
  answer: "Grouping tools based on their uses"
},
{
  question: "Which of the following is an example of a resistant material?",
  options: [
    "Paper",
    "Fabric",
    "Metal",
    "Rubber"
  ],
  answer: "Metal"
},

  {
    question: "When using a sewing machine, why should you avoid sewing over pins?",
    options: [
      "It sharpens the needle",
      "It breaks the needle and may cause injury",
      "It saves time",
      "It improves stitching"
    ],
    answer: "It breaks the needle and may cause injury"
  }
];
export default jhscareerTechQuestions;